import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '@/lib/analytics';

export function ReactRouterAnalyticsProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  useEffect(() => {
    // Initialize analytics on app start
    analytics.getSessionId();
  }, []);

  useEffect(() => {
    // Track page changes for client-side navigation
    const pathname = location.pathname + location.search;
    analytics.updateCurrentPage(pathname);

    // Track page view event (internal analytics)
    analytics.trackEvent('page_view', 'navigation', {
      page: pathname,
      timestamp: new Date().toISOString(),
      referrer: document.referrer
    });

    // Send page view to Google Analytics
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'page_view', {
        page_path: pathname,
        page_title: document.title,
        page_location: window.location.href
      });
    }
  }, [location]);

  return <>{children}</>;
}